import {LicensePanel} from '@common/billing/billing-page/panels/license-panel/license-panel';

export function LicensePage() {
  return (
    <div className="container mx-auto p-0 md:p-24 max-w-1280">
      <LicensePanel />
    </div>
  );
}
